import React from "react";
const LoaderEx = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "loading white" },
            React.createElement("div", { className: "loading-spinner-center-top" },
                React.createElement("div", { className: "lds-spinner" },
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null)),
                React.createElement("div", { className: "taCenter" }, props.showMsg !== false &&
                    (React.createElement("p", { className: "DMSans_16_500 txt_primaryGrey mt-5 " }, props.loaderMsg ? props.loaderMsg : "Processing your order Please wait")))))));
};
export default LoaderEx;
